import { createBrowserHistory } from 'history'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import createApolloClient from './apollo-client'
import config from './config'

declare global {
  interface Window {
    environment: any
  }
}

async function bootstrap() {
  const [environment, apolloClient] = await Promise.all([
    fetch(config.serviceContext + '/environment/').then((res) => res.json()),
    createApolloClient(),
  ])

  // save environment to global window
  // so it's available throughout application
  window.environment = environment

  try {
    ReactDOM.render(
      <App basename={process.env.PUBLIC_URL} history={createBrowserHistory()} apolloClient={apolloClient} />,
      document.getElementById('root')
    )
  } catch (err) {
    if (err === 'ResizeObserver loop limit exceeded') {
      console.log('Ignored: ResizeObserver loop limit exceeded')
    } else {
      throw err
    }
  }
}

bootstrap()
